
import React, { useEffect, useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  CircularProgress,
  Box
} from '@material-ui/core';
import { useGoVehisService } from '../../utils/axios';

const ContactDataDialog = ({ isOpen = false, onClose, contactDataId = null }) => {
  const goVehisService = useGoVehisService();
  const [contactRows, setContactRows] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isOpen && contactDataId) {
      setLoading(true);
      goVehisService.get(`/admin/contactDataFromImport/${contactDataId}`)
        .then(res => res.data)
        .then(data => {
          setContactRows([
            { label: 'Nazwa', value: data.name },
            { label: 'NIP', value: data.nip },
            { label: 'Telefon', value: data.phone },
            { label: 'Email', value: data.email }
          ]);
        })
        .catch(error => {
          console.error('Cannot get contact data', error);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [isOpen, contactDataId]);

  return (
    <Dialog onClose={onClose} aria-labelledby="contact-data-dialog-title" open={isOpen}>
      <DialogTitle id="contact-data-dialog-title">
        Dane dostawcy
      </DialogTitle>
      <DialogContent dividers style={{ minWidth: '450px' }}>
        {loading ? (
          <Box display="flex" justifyContent="center" my={3}>
            <CircularProgress />
          </Box>
        ) : (
          contactRows.length > 0 && (
            <TableContainer component={Paper}>
              <Table aria-label="contact data table">
                <TableBody>
                  {contactRows.map((row) => (
                    <TableRow key={row.label}>
                      <TableCell component="th" scope="row">
                        <strong>{row.label}</strong>
                      </TableCell>
                      <TableCell align="right">{row.value || '-'}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )
        )}
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={onClose} color="primary">
          Zamknij
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ContactDataDialog;
